"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuth = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var setAuth = function setAuth(authData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.SET_AUTH)(authData));
  };
};

exports.setAuth = setAuth;